import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { format } from "date-fns";


import { CardPromptProps } from "./types";
import {
  selectDailyAveragePromptLoadingState,
  selectDailyAveragePromptScoresState,
  selectPromptRangeValuesState,
  selectWeeklyPromptScoresState,
} from "../../store/selectors/scores";
import CardChartWithCalendar from "../CardChartWithCalendar";
import { ERoutes } from "../../constants/routes";
import { changePromptStatus } from "../../store/prompts/slice";



const CardPrompt: FC<CardPromptProps> = ({ item, currentBrandId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const brandId = Number(currentBrandId);
  const promptId = Number(item.id);

  const dailyAveragePromptLoading = useSelector(selectDailyAveragePromptLoadingState);
  const weeklyScores = useSelector(selectWeeklyPromptScoresState(brandId, promptId));
  const dailyAveragePromptScores = useSelector(
    selectDailyAveragePromptScoresState(brandId, promptId),
  );
  const rangeValues = useSelector(selectPromptRangeValuesState);


  const handleDotClick = (created_at: string, promptId: string) => {
    const formattedDate = format(new Date(created_at), 'yyyy-MM-dd');
    navigate(ERoutes.PromptsDayly.replace(":id", String(currentBrandId)).replace(":date", formattedDate) + `#${promptId}`);
  }
  
  const handleHidePrompt = (id: string, value: boolean) => {
    dispatch(changePromptStatus({ id, status: value }));
  }
  
  

  return (
    <CardChartWithCalendar
      item={item}
      type="prompt"
      linkFormat={ERoutes.PromptsDayly}
      hideItemTitle='Remove prompt from scoring'
      currentBrandId={currentBrandId}
      dailyAverageLoading={dailyAveragePromptLoading}
      dailyAverageScores={dailyAveragePromptScores}
      rangeValues={rangeValues || undefined}
      weeklyScores={weeklyScores || undefined}
      weeklyScoresLoading={dailyAveragePromptLoading}
      onDotClick={(created_at) => handleDotClick(created_at, item.id)}
      onHideItem={handleHidePrompt}
    />
  );
};

export default CardPrompt;
